import type { ReactNode } from 'react'

import styles from './PageHead.module.css'

export function PageHead({ title, sub, badge }: { title: string; sub: string; badge: ReactNode }) {
  return (
    <header className={styles.head}>
      <div>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.sub}>{sub}</div>
      </div>
      {badge}
    </header>
  )
}
